import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import "./ourservices2.css";
import Item1 from "../../../assets/servicessoftware1.png";
import Item1H from "../../../assets/Item1H.png";
import Item2 from "../../../assets/Item2.png";
import Item2H from "../../../assets/Item2H.png";
import Item3 from "../../../assets/servicessoftware3.png";
import Item3H from "../../../assets/Item3H.png";
import Item4 from "../../../assets/Item4.png";
import Item4H from "../../../assets/Item4H.png";
import Item5 from "../../../assets/Item5.png";
import Item5H from "../../../assets/Item5H.png";
import Item6 from "../../../assets/Item6.png";
import Item6H from "../../../assets/Item6H.png";
import Item7 from "../../../assets/Item7.png";
import Item7H from "../../../assets/Item7H.png";
import Item8 from "../../../assets/Item8.png";
import Item8H from "../../../assets/Item8H.png";
import Item9 from "../../../assets/Item9.png";
import Item9H from "../../../assets/Item9H.png";
import Logo from "../../../assets/Logos/2/colored.svg";
import { useTranslation } from "react-i18next";

const Ourservices2 = () => {
  const { t } = useTranslation("global");
  const { lang } = useParams();
  const [hovered, setHovered] = useState(null);
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  // Original sections array with translated text
  const sections = [
    {
      id: 1,
      title: t("ourServices.section2.softwareSolutions.title"),
      subtitle: t("ourServices.section2.softwareSolutions.subtitle"),
      description: t("ourServices.section2.softwareSolutions.description"),
      link: "/SoftwareSolutions",
      services: [
        {
          title: t(
            "ourServices.section2.softwareSolutions.services.webDevelopment.title"
          ),
          defaultImage: Item1,
          hoverImage: Item1H,
          hoverText: t(
            "ourServices.section2.softwareSolutions.services.webDevelopment.hoverText"
          ),
          link: "/SoftwareSolutions",
        },
        {
          title: t(
            "ourServices.section2.softwareSolutions.services.erpCrm.title"
          ),
          defaultImage: Item2,
          hoverImage: Item2H,
          hoverText: t(
            "ourServices.section2.softwareSolutions.services.erpCrm.hoverText"
          ),
          link: "/SoftwareSolutions",
        },
        {
          title: t(
            "ourServices.section2.softwareSolutions.services.lowCode.title"
          ),
          defaultImage: Item3,
          hoverImage: Item3H,
          hoverText: t(
            "ourServices.section2.softwareSolutions.services.lowCode.hoverText"
          ),
          link: "/SoftwareSolutions",
        },
      ],
    },
    {
      id: 2,
      title: t("ourServices.section2.creativeDesign.title"),
      subtitle: t("ourServices.section2.creativeDesign.subtitle"),
      description: t("ourServices.section2.creativeDesign.description"),
      link: "/CreativeDesign",
      services: [
        {
          title: t("ourServices.section2.creativeDesign.services.uiUx.title"),
          defaultImage: Item4,
          hoverImage: Item4H,
          hoverText: t(
            "ourServices.section2.creativeDesign.services.uiUx.hoverText"
          ),
          link: "/CreativeDesign",
        },
        {
          title: t(
            "ourServices.section2.creativeDesign.services.brandIdentity.title"
          ),
          defaultImage: Item5,
          hoverImage: Item5H,
          hoverText: t(
            "ourServices.section2.creativeDesign.services.brandIdentity.hoverText"
          ),
          link: "/CreativeDesign",
        },
        {
          title: t(
            "ourServices.section2.creativeDesign.services.graphicDesign.title"
          ),
          defaultImage: Item6,
          hoverImage: Item6H,
          hoverText: t(
            "ourServices.section2.creativeDesign.services.graphicDesign.hoverText"
          ),
          link: "/CreativeDesign",
        },
      ],
    },
    {
      id: 3,
      title: t("ourServices.section2.advertisingMedia.title"),
      subtitle: t("ourServices.section2.advertisingMedia.subtitle"),
      description: t("ourServices.section2.advertisingMedia.description"),
      link: "/AdvertisingAndMedia",
      services: [
        {
          title: t(
            "ourServices.section2.advertisingMedia.services.marketingStrategy.title"
          ),
          defaultImage: Item7,
          hoverImage: Item7H,
          hoverText: t(
            "ourServices.section2.advertisingMedia.services.marketingStrategy.hoverText"
          ),
          link: "/AdvertisingAndMedia",
        },
        {
          title: t(
            "ourServices.section2.advertisingMedia.services.socialMedia.title"
          ),
          defaultImage: Item8,
          hoverImage: Item8H,
          hoverText: t(
            "ourServices.section2.advertisingMedia.services.socialMedia.hoverText"
          ),
          link: "/AdvertisingAndMedia",
        },
        {
          title: t(
            "ourServices.section2.advertisingMedia.services.videoProduction.title"
          ),
          defaultImage: Item9,
          hoverImage: Item9H,
          hoverText: t(
            "ourServices.section2.advertisingMedia.services.videoProduction.hoverText"
          ),
          link: "/AdvertisingAndMedia",
        },
      ],
    },
  ];

  // Rest of the component remains exactly the same
  useEffect(() => {
    const detectTouch = () => {
      setIsTouchDevice(true);
      window.removeEventListener("touchstart", detectTouch);
    };

    window.addEventListener("touchstart", detectTouch);
    const hasHover = window.matchMedia("(hover: hover)").matches;
    setIsTouchDevice(!hasHover);

    return () => {
      window.removeEventListener("touchstart", detectTouch);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleItemClick = (itemId) => {
    if (isTouchDevice) {
      if (hovered === itemId) {
        return;
      } else {
        setHovered(itemId);
      }
    }
  };

  return (
    <section className="services-container" aria-label="Our services offerings">
      {sections.map((section) => (
        <article className="service-section" key={section.id}>
          <div className="service-info">
            <img
              src={Logo || "/placeholder.svg"}
              alt="Virtue Logo"
              loading="lazy"
              width="120"
              height="40"
            />
            <h2 id={`service-heading-${section.id}`}>{section.title}</h2>
            <p>{section.subtitle}</p>
            <p>{section.description}</p>
            <Link to={`/${lang}${section.link}`} onClick={scrollToTop}>
              <button className="explore-button">
                {t("ourServices.section2.exploreButton")}
              </button>
            </Link>
          </div>
          <div className="service-items">
            {section.services.map((service, index) => (
              <article
                key={index}
                className={`service-item ${
                  hovered === `${section.id}-${index}` ? "hovered" : ""
                }`}
                onMouseEnter={() =>
                  !isTouchDevice && setHovered(`${section.id}-${index}`)
                }
                onMouseLeave={() => !isTouchDevice && setHovered(null)}
                onClick={() => handleItemClick(`${section.id}-${index}`)}
                role="button"
                tabIndex={0}
                aria-label={`Learn more about ${service.title}`}
              >
                <img
                  src={
                    hovered === `${section.id}-${index}`
                      ? service.hoverImage
                      : service.defaultImage
                  }
                  alt={service.title}
                  className="service-icon"
                  loading="lazy"
                  width="64"
                  height="64"
                />
                <h3
                  className={
                    hovered === `${section.id}-${index}` ? "hovered-title" : ""
                  }
                >
                  {service.title}
                </h3>
                {hovered === `${section.id}-${index}` && (
                  <>
                    <p className="hover-text">
                      {service.hoverText}
                      <Link
                        to={`/${lang}${service.link}`}
                        onClick={scrollToTop}
                        className="services-link"
                      >
                        {t("ourServices.section2.learnMore")}
                      </Link>
                    </p>
                  </>
                )}
                {isTouchDevice && !hovered && (
                  <span className="touch-indicator" aria-hidden="true"></span>
                )}
              </article>
            ))}
          </div>
        </article>
      ))}
    </section>
  );
};

export default Ourservices2;
